import { request } from './apiClient';
import { getSessionClientId } from './authSession';

// Monta o payload JSON de concretagem (com metadados dos anexos) usado no update.
export const buildConcretagemPayload = (formData, anexosSelecionados) => {
  // AJUSTE BACKEND AQUI: estrutura de metadados dos anexos enviada no payload.
  const anexosPayload = anexosSelecionados.map((file) => ({
    nome: file.name,
    tipo: file.type,
    tamanho: file.size,
  }));

  // AJUSTE BACKEND AQUI: mapeamento de campos do formulario para o contrato da API.
  const payload = {
    idCliente: getSessionClientId(),
    idObra: formData.idObra,
    dataConcretagem: formData.dataConcretagem,
    quantidadeCaminhao: Number(formData.qtdCaminhoes),
    quantidadeTotalCp: Number(formData.qtdTotalCp),
    idRespMoldagem: formData.idResponsavelMoldagem,
    idRespDigitacao: formData.idResponsavelDigitacao,
  };

  if (anexosPayload.length > 0) {
    payload.anexos = anexosPayload;
  }

  return payload;
};

// Lista todas as concretagens realizadas.
export const getConcretagemRealizada = async () => {
  // AJUSTE BACKEND AQUI: endpoint de listagem de concretagens.
  const idCliente = getSessionClientId();
  return await request(`/api/concretagemRealizada?idCliente=${idCliente}`);
};

// Cria uma concretagem enviando os anexos como multipart/form-data; retorna { response, payload }.
export const createConcretagemRealizada = async (formData, anexosSelecionados) => {
  const formPayload = new FormData();

  const idCliente = getSessionClientId();
  if (idCliente) formPayload.append('idCliente', idCliente);

  if (formData.idObra) formPayload.append('idObra', formData.idObra);
  if (formData.dataConcretagem) formPayload.append('dataConcretagem', formData.dataConcretagem);
  if (formData.qtdCaminhoes) formPayload.append('quantidadeCaminhao', Number(formData.qtdCaminhoes));
  if (formData.qtdTotalCp) formPayload.append('quantidadeTotalCp', Number(formData.qtdTotalCp));
  if (formData.idResponsavelMoldagem) formPayload.append('idRespMoldagem', formData.idResponsavelMoldagem);
  if (formData.idResponsavelDigitacao) formPayload.append('idRespDigitacao', formData.idResponsavelDigitacao);

  if (anexosSelecionados && anexosSelecionados.length > 0) {
    anexosSelecionados.forEach(file => {
      formPayload.append('anexos', file);
    });
  }

  // AJUSTE BACKEND AQUI: endpoint de criacao de concretagem.
  const response = await request('/api/concretagemRealizada', {
    method: 'POST',
    body: formPayload
  });

  const legacyPayload = buildConcretagemPayload(formData, anexosSelecionados);
  return { response, payload: legacyPayload };
};

// Atualiza os dados da concretagem por id (JSON); retorna { response, payload }.
// O PUT não recebe arquivos: anexos novos vão por uploadAnexosConcretagem.
export const updateConcretagemRealizada = async (id, formData) => {
  const payload = buildConcretagemPayload(formData, []);
  payload.idConcretagemRealizada = Number(id);

  // AJUSTE BACKEND AQUI: update por id da concretagem.
  const response = await request(`/api/concretagemRealizada/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Exclui a concretagem por id.
export const deleteConcretagemRealizada = async (id) => {
  // AJUSTE BACKEND AQUI: exclusao por id da concretagem.
  return await request(`/api/concretagemRealizada/${id}`, {
    method: 'DELETE'
  });
};

// Gera uma URL temporária (SAS) para baixar/abrir um anexo; exige estar logado e o anexo ser do cliente da sessão.
export const getAnexoDownloadUrl = async (idConcretagem, idArquivo) => {
  return await request(`/api/concretagemRealizada/${idConcretagem}/anexos/${idArquivo}/download`);
};

// Anexa novos arquivos a uma concretagem já cadastrada; retorna os anexos criados.
export const uploadAnexosConcretagem = async (idConcretagem, arquivos) => {
  const formPayload = new FormData();
  arquivos.forEach(file => {
    formPayload.append('anexos', file);
  });

  return await request(`/api/concretagemRealizada/${idConcretagem}/anexos`, {
    method: 'POST',
    body: formPayload
  });
};

// Exclui um anexo já salvo da concretagem.
export const deleteAnexoConcretagem = async (idConcretagem, idArquivo) => {
  return await request(`/api/concretagemRealizada/${idConcretagem}/anexos/${idArquivo}`, {
    method: 'DELETE'
  });
};